<template>
  <div>
    <div v-if="libros.length > 0" class="vx-row w-full">
      <!--LIBRO WEB-->
      <div class="padre vx-col w-full sm:1/2 md:w-1/5 xl:w-1/5" @click="datosStorage(libros[0]);datolibro(libros[0])">
        <img v-bind:src="$data_url+'archivos/upload/libro/'+libros[0].weblibro+'/'+libros[0].portada" alt="Imagen de fondo" class="imagen">
        <div class="hijo">
          <div class="letrac" >
            <p class="font-bold">Libro</p>
            <p>Web</p>
          </div>
        </div>
      </div>
      <!--LIBRO GUIA-->
      <div class="padre vx-col w-full sm:1/2 md:w-1/5 xl:w-1/5" @click="datosStorage(libros[0]);datopdfconguia(libros[0])" v-if="libros[0].pdfconguia!== null && libros[0].pdfconguia!== '' && libros[0].pdfconguia!== 'null'">
        <img v-bind:src="$data_url+'archivos/upload/desglose_libros/img_pdf2.png'" alt="Imagen de fondo" class="imagen">
        <div class="hijo">
          <div class="letrac" >
            <p class="font-bold">PDF</p>
            <p>Con guía</p>
          </div>
        </div>
      </div>
      <!--LIBRO GUIA-->
      <!-- <div class="padre vx-col w-full sm:1/2 md:w-1/5 xl:w-1/5" @click="datosStorage(libros[0]);datopdfconguia(libros[0])" v-if="libros[0].pdfconguia!== null && libros[0].pdfconguia!== '' && libros[0].pdfconguia!== 'null'">
        <img v-bind:src="$data_url+'archivos/upload/desglose_libros/img_pdf2.png'" alt="Imagen de fondo" class="imagen">
        <div class="hijo">
          <div class="letrac" >
            <p class="font-bold">PDF</p>
            <p>Con guía</p>
          </div>
        </div>
      </div> -->
      <!--GUIA DIDACTICA-->
      <div class="padre vx-col w-full sm:1/2 md:w-1/5 xl:w-1/5" @click="datosStorage(libros[0]);datopdfguiadidactica(libros[0])" v-if="libros[0].id_serie !== 6 && libros[0].guiadidactica!== null && libros[0].guiadidactica!== '' && libros[0].guiadidactica!== 'null'">
        <img v-bind:src="$data_url+'archivos/upload/desglose_libros/img_pdf1.png'" alt="Imagen de fondo" class="imagen">
        <div class="hijo">
          <div class="letrac" >
            <p class="font-bold">Guía</p>
            <p>Didáctica</p>
          </div>
        </div>
      </div>
      <!--UNIDADES-->
      <template v-for="(item) in unidadesLibro">
        <div class="padre w-full sm:1/2 md:w-1/5 xl:w-1/5" @click="datosStorage(libros[0]);iractividades(item)">
          <img style="width: 100%;" class="imagen" v-bind:src="$data_url+'archivos/upload/libro/'+item.weblibro+'/portadas/unidad'+item.unidad+'.jpg'" alt="Imagen de fondo">
          <div class="hijo">
            <div class="letrac" >
              <p class="font-bold">
                <span v-if="item.txt_nombre_unidad == '' || item.txt_nombre_unidad == 'null' || item.txt_nombre_unidad === null">
                Unidad
                </span>
                <span v-else>
                {{item.txt_nombre_unidad}}
                </span>
                {{item.unidad}}
              </p>
              <small>
                  {{item.nombre_unidad}}
              </small>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import historicoMixin from "@/mixins/historicomix";
export default{
  mixins:[historicoMixin],
  data(){
    return{
      usuario:[],
      miusuario: '',
      grupo_usuario: '',
    }
  },
  props:{
    unidadesLibro:{
      type:Array,
      default:function(){
        return []
      }
    },
    libros:{
      type:Array,
      default:function(){
        return []
      }
    },
  },
  created(){
    let me = this
    me.usuario = JSON.parse(localStorage.getItem('usuario'));
    me.miusuario = me.usuario;
    me.grupo_usuario = me.miusuario.id_group;
  },
  methods:{
    datosStorage(url){
      let me = this
      localStorage.nombrelibroSelec = url.nombrelibro
      localStorage.carpetaLibroSelec = url.weblibro
    },
    datolibro(url) {
      let me = this;
      localStorage.url = url.weblibro;
      for (let index = 0; index < me.unidadesLibro.length; index++) {
          if (index == 0) {
              localStorage.pag_inicio = me.unidadesLibro[index].pag_inicio
          }
          localStorage.pag_fin = me.unidadesLibro[index].pag_fin

      }
      let h_idinstitucion = me.miusuario.institucion_idInstitucion;
      let h_idusuario = me.miusuario.idusuario;
      let h_idgrupo = me.miusuario.id_group;
      let h_idasignatura = url.idasignatura
      let h_nombreasignatura = url.nombreasignatura
      let h_recursotipo = 1; //1 = libro
      let datoHistorico = {
          'user_nombre': me.miusuario.nombres,
          'user_apellido': me.miusuario.apellidos,
          'user_email': me.miusuario.email,
          'user_cedula': me.miusuario.cedula,
          'recurso_accion': 'ver',
          'recurso_tipo': 'libro',
          'recurso_nombre': url.nombrelibro,
          'recurso_detalle': 'libro completo',
      }
      // console.log(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura, h_nombreasignatura, h_recursotipo,datoHistorico)
      me.historicoVisitas(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura, h_nombreasignatura, h_recursotipo, datoHistorico);
      me.saveHistoricoVisitas(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura,h_nombreasignatura,  h_recursotipo,datoHistorico)
      localStorage.vistalibro = 'por_unidad'
      // this.$router.push('/docente/libro/digital');
      let route = this.$router.resolve({
          path: '/docente/libro/digital'
      });

      window.open(route.href, '_blank');
    },
    datopdfconguia(url) {
      let me = this
      // console.log(url)
      // return
      if (me.grupo_usuario == 9) {
          this.$vs.notify({
              text: 'El archivo no esta disponible en la version DEMO',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-triangle'
          })
          return
      }
      if (url.pdfconguia === null || url.pdfconguia === 'null') {
          me.$vs.notify({
              text: 'El PDF con guía aun no está disponible',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-triangle'
          })
          return
      }
      let h_idinstitucion = me.miusuario.institucion_idInstitucion;
      let h_idusuario = me.miusuario.idusuario;
      let h_idgrupo = me.miusuario.id_group;
      let h_idasignatura = url.idasignatura
      let h_nombreasignatura = url.nombreasignatura
      let h_recursotipo = 12; //12 = pdf con guia
      let datoHistorico = {
          'user_nombre': me.miusuario.nombres,
          'user_apellido': me.miusuario.apellidos,
          'user_email': me.miusuario.email,
          'user_cedula': me.miusuario.cedula,
          'recurso_accion': 'ver',
          'recurso_tipo': 'pdf con guia',
          'recurso_nombre': url.pdfconguia,
          'recurso_detalle': 'libro pdf guia',
      }
      // console.log(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura, h_nombreasignatura, h_recursotipo,datoHistorico)
      me.historicoVisitas(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura, h_nombreasignatura, h_recursotipo, datoHistorico);
      me.saveHistoricoVisitas(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura,h_nombreasignatura,  h_recursotipo,datoHistorico)
      localStorage.url_guia = url.pdfconguia;
      window.open('/docente/libro/pdfconguia', '_blank');
    },
    datopdfguiadidactica(url) {
      let me = this
      if (me.grupo_usuario == 9) {
        this.$vs.notify({
            text: 'El archivo no esta disponible en la version DEMO',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-triangle'
        })
        return
      }
      if (url.guiadidactica === null || url.guiadidactica === 'null') {
        me.$vs.notify({
            text: 'La guía didáctica aun no está disponible',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-triangle'
        })
        return
      }

      let h_idinstitucion = me.miusuario.institucion_idInstitucion;
      let h_idusuario = me.miusuario.idusuario;
      let h_idgrupo = me.miusuario.id_group;
      let h_idasignatura = url.idasignatura
      let h_nombreasignatura = url.nombreasignatura
      let h_recursotipo = 14; //12 = guia didactica
      let datoHistorico = {
          'user_nombre': me.miusuario.nombres,
          'user_apellido': me.miusuario.apellidos,
          'user_email': me.miusuario.email,
          'user_cedula': me.miusuario.cedula,
          'recurso_accion': 'ver',
          'recurso_tipo': 'guia didactica',
          'recurso_nombre': url.guiadidactica,
          'recurso_detalle': '',
      }
      // console.log(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura, h_nombreasignatura, h_recursotipo,datoHistorico)
      me.historicoVisitas(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura, h_nombreasignatura, h_recursotipo, datoHistorico);
      me.saveHistoricoVisitas(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura,h_nombreasignatura,  h_recursotipo,datoHistorico)
      localStorage.url_guiadid = url.guiadidactica;
      window.open('/docente/libro/pdfguiadidactica', '_blank');
    },
    iractividades(item) {
      let me = this;
      localStorage.url = item.weblibro
      localStorage.indexUnidad = item.unidad
      localStorage.valUnidad = item.unidad
      localStorage.idUnidad = item.id_unidad_libro
      localStorage.pag_inicio = item.pag_inicio
      localStorage.pag_fin = item.pag_fin

      let h_idinstitucion = me.miusuario.institucion_idInstitucion;
      let h_idusuario = me.miusuario.idusuario;
      let h_idgrupo = me.miusuario.id_group;
      let h_idasignatura = localStorage.idasignatura
      let h_nombreasignatura = localStorage.nombreasignatura
      let h_recursotipo = 1; //1 = libro
      let datoHistorico = {
          'user_nombre': me.miusuario.nombres,
          'user_apellido': me.miusuario.apellidos,
          'user_email': me.miusuario.email,
          'user_cedula': me.miusuario.cedula,
          'recurso_accion': 'ver',
          'recurso_tipo': 'libro unidad',
          'recurso_nombre': 'unidad ' + item.unidad,
          'recurso_detalle': item.nombre_unidad,
      }
      // console.log(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura, h_nombreasignatura, h_recursotipo,datoHistorico)
      me.historicoVisitas(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura, h_nombreasignatura, h_recursotipo, datoHistorico);
      me.saveHistoricoVisitas(h_idinstitucion, h_idusuario, h_idgrupo, h_idasignatura,h_nombreasignatura,  h_recursotipo,datoHistorico)
      if (this.grupo_usuario == 10) {
          // perfil director
          this.$router.push('/director/institucion/docentes/contenidos/libro/unidad');
      }
      if (this.grupo_usuario == 16){
          this.$router.push('/colegios/docente/libro/desgloseunidad');
      }
      else {
          this.$router.push('/docente/libro/desgloseunidad');
      }
    },
  }
}
</script>
 <style>
  .letrascard {
      padding: 10px 0px 10px 0px;
      color: white;
      font-size: 17px;
      position: relative;
      -webkit-box-shadow: inset 0px 0px 29px 200px rgba(0, 0, 0, 0.52);
      -moz-box-shadow: inset 0px 0px 29px 200px rgba(0, 0, 0, 0.52);
      box-shadow: inset 0px 0px 29px 200px rgba(0, 0, 0, 0.52);
  }
  .letrac{
    font-size: 14px;
  }

  .btn_ver {
      font-size: 14px;
      padding: 5px 15px 5px 15px !important;
  }

  .imagencard {
      border-radius: 6px;
  }
  .padre {
    position: relative;
    box-sizing: border-box;
    background-color: #fafafa;
    margin: 20px;
  }

  .imagen {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Para ajustar la imagen al tamaño del contenedor */
    display: block; /* Para eliminar espacios en línea si es un contenedor en línea */
    border-radius: 6px;
  }

  .hijo {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(173, 216, 230, 0.7); /* Color de fondo semitransparente */
    padding: 10px;
    box-sizing: border-box;
    color: white; /* Color del texto */
    text-align: center;
    font-size: 15px;
    -webkit-box-shadow: inset 0px 0px 29px 200px rgba(0, 0, 0, 0.60);
    -moz-box-shadow: inset 0px 0px 29px 200px rgba(0, 0, 0, 0.60);
    box-shadow: inset 0px 0px 29px 200px rgba(0, 0, 0, 0.60);
}
  </style>
